module.exports = "./img/306afc1b4b0f7826fd2306d39628452f.jpg";